import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

const RelatedProductsCards = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 24px;
  padding-top: 24px;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.12);

  @media (min-width: ${breakpoints.sm}px) {
    justify-content: space-around;
  }
`;

const relatedProductsListPropertyTypes = {
  children: PropTypes.node,
};

type RelatedProductsListProperties = InferProps<
  typeof relatedProductsListPropertyTypes
>;

const RelatedProductsList = ({ children }: RelatedProductsListProperties) => (
  <RelatedProductsCards>
    {children}
  </RelatedProductsCards>
);

RelatedProductsList.propTypes = relatedProductsListPropertyTypes;

export default RelatedProductsList;
